export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  USERS: '/users',
  LOGS: '/logs',
  STAFF: '/staff',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

export interface NavItem {
  labelKey: string;
  path: RoutePath;
}

export const NAV_ITEMS: NavItem[] = [
  { labelKey: 'dashboard', path: ROUTES.DASHBOARD },
  { labelKey: 'users', path: ROUTES.USERS },
  { labelKey: 'staff', path: ROUTES.STAFF },
  { labelKey: 'logs', path: ROUTES.LOGS },
];
